import React from "react";
import AppHeader from "../components/AppHeader";
import ShareLinkCards from "../components/ShareLinkCards";

export default function ShareLinks() {
  return (
    <>
      <AppHeader title="Shareable Links" back />
      <div className="sg-main sg-fade-in">
        <p style={{ color: "var(--muted)", fontSize: 13, margin: "0 0 18px" }}>
          Share these links with prospective customers. They can onboard or book a meeting — no login required.
        </p>
        <ShareLinkCards />
      </div>
    </>
  );
}
